<template>
  <b-modal class="modal-md" id="videoTutorialPreviewModal" ref="videoTutorialPreviewModal" title="Video Tutorial Preview" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @hide="closeModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'money-check']" size="1x" class="mr-2"/> Video Tutorial Preview</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default" slot-scope="{ close }">
      <div class="preview-modal-content" v-if="isLoading">
        Loading..
      </div>
      <div class="preview-modal-content" v-else>
        <h5>{{ video.description }}</h5>
        <video width="100%" height="auto" controls>
          <source :src="baseUrl + video.basename" :type="'video/' + ext">
          Your browser does not support the video tag.
        </video>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel, close }">
      <div>
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary mr-2" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>Close
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'VideoTutorialPreviewModal',
  props: ['video', 'baseUrl'],
  data () {
    return {
      isLoading: false,
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    ext() {
      if (!this.video) {
        return 'mp4';
      }
      if (this.video.extension) {
        return this.video.extension;
      }
      if (this.video.basename.includes('.')) {
        return this.video.basename.split('.').pop() || 'mp4';
      }
      return 'mp4';
    }
  },
  methods:{
    closeModal() {
      this.$parent.closeModal()
      this.$emit('close')
    },
  },
  created() {

  },
  components: {

  }
}
</script>

<style scoped>
.flex-align {
  display: flex;
  align-items: center;
}

.remove-icon {
  font-size: 24px;
  color: red;
  cursor: pointer;
}
</style>
